import PinchZoom from "pinch-zoom-js";
import app from "../_app";

if(app.viewport.isEqualOrSmallerThan('md')) {
    const productPinchImages = [...document.querySelectorAll('.js-product-pinch-image')];

    productPinchImages.map(pinchImage => {
        const pinchStartHandler = () => {
            if(!pinchImage.hasAttribute('data-loaded')) {
                const image = new Image();
                image.src = pinchImage.dataset.originalImage;
                image.onload = () => {
                    const imageElement = pinchImage.querySelector('img');
                    const ratioX = 1 / imageElement.naturalWidth * image.naturalWidth;
                    const ratioY = 1 / imageElement.naturalHeight * image.naturalHeight;

                    if(pinchImage.style.transform.includes(' translate3d(')) {
                        let transform = pinchImage.style.transform.split(' translate3d(');

                        const translate = transform[1].split(')')[0];
                        const [x, y] = translate.replace(/[px]/g, '').split(', ');

                        imageElement.src = image.src;
                        pinchImage.style.transform = `${transform[0]} translate3d(${parseFloat(x) * ratioX}px, ${parseFloat(y) * ratioY}px, 0px)`;
                    }

                    pinchImage.querySelector('.js-product-image-pinch-srcset').srcset = image.src;
                }

                pinchImage.setAttribute('data-loaded', '');
            }
        };

        new PinchZoom(pinchImage, {
            draggableUnzoomed: false,
            onZoomStart: pinchStartHandler,
            onDoubleTap: pinchStartHandler,
        });
    });
}
